import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';

import SpinnerBlock from '../../common/SpinnerBlock';
import EditOrLock from './common/EditOrLock';

import { showModal } from '../../../actions/modal';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  border: 1px solid #ebebeb;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .card-title {
    padding-top: 3px;
    padding-bottom: 13px;
    h4 {
      font-size: 16px;
    }
  }
`;

const CommentBlock = (props) => {
  const { currentOrder, haveProducts, loadingComment, handleEditComment } = props;

  const dispatch = useDispatch();

  const { t } = useAutoTranslation();

  const handleCommentModal = () => {
    dispatch(
      showModal('EditOrderComment', {
        currentOrder,
        submitCallback: handleEditComment,
      }),
    );
  };

  return (
    <Wrapper className={`card-box ${!haveProducts ? 'disabled' : ''}`}>
      <SpinnerBlock show={loadingComment} />
      <div style={{ display: 'flex' }} className="card-title">
        <h4 className="header-title">{t('Комментарии')}</h4>
        {haveProducts ? (
          <div className="change-link" style={{ marginLeft: 'auto' }} onClick={handleCommentModal}>
            {t('Добавить')}
          </div>
        ) : null}
      </div>
      {haveProducts ? (
        <Fragment>
          <div className="border-top" />
          {currentOrder.comment ? (
            <div className="comment-item">
              <div className="block-subtitle">{t('Комментарий')}</div>
              <div>{currentOrder.comment}</div>
            </div>
          ) : null}
          {currentOrder.operatorComment ? (
            <div className="comment-item">
              <div className="block-subtitle">{t('Комментарий оператору')}</div>
              <div>{currentOrder.operatorComment}</div>
            </div>
          ) : null}
          {currentOrder.delivery &&
          currentOrder.delivery.type === 'PVZ' &&
          currentOrder.delivery.deliveryComment ? (
            <div className="comment-item">
              <div className="block-subtitle">{t('Комментарий по доставке')}</div>
              <div>{currentOrder.delivery.deliveryComment}</div>
            </div>
          ) : null}
        </Fragment>
      ) : (
        <div className="blocked-block">
          <div className="block-subtitle">{t('Изменения не доступны')}</div>
        </div>
      )}
    </Wrapper>
  );
};

export default CommentBlock;
